module.exports = __webpack_public_path__ + "static/48-e181a4b425428eb780ec69a4158dfa83.png";